export default {
  name: 'extranet',
  lookup() {
    return window.EEContext && window.EEContext.language && window.EEContext.language.substr(0, 2);
  },
};
